// Row 2 — typographic position counter, `M of N kanji`. Per §12.1 LOCKED:
// not a percentage bar with chromatic fill (that imports the Brilliant
// register §7.1 explicitly bans); a marginalia-register text strip only.
// Numerator is unique-kanji-correct (failed kanji re-queue without
// incrementing); denominator is unique-kanji-count for the batch.
//
// Same text-meta / muted-fg / uppercase / tabular tracking as the marginalia
// strip above. Lighter visual weight is achieved through the smaller token
// scale and absence of separator dots, not through a different register.
export function ProgressStrip({
    answered,
    total,
}: {
    answered: number
    total: number
}) {
    return (
        <p className="mt-2 text-meta text-muted-fg uppercase tabular-nums">
            <span>{answered}</span>
            <span className="mx-1.5">of</span>
            <span>{total}</span>
            <span className="ml-1.5">kanji</span>
        </p>
    )
}
